export interface SaleResult {
    amount: number;
    created: string;
    id: number;
    is_overwritten: boolean;
    item_id: number;
    sale_id: number;
    type: SaleResultType;
    updated: string;
    user_id: number;
}

export enum SaleResultType {
    LiveBid = "live_bid",
    Physical = "physical",
    SecretOrder = "secret_order",
    Unsold = "unsold"
}
